import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var InfoCircle = function InfoCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM11.9248 8.49512C11.0654 8.49512 10.3779 7.80762 10.3779 6.95898C10.3779 6.08887 11.0654 5.40137 11.9248 5.40137C12.7734 5.40137 13.4502 6.08887 13.4502 6.95898C13.4502 7.80762 12.7734 8.49512 11.9248 8.49512ZM10.002 18.335C9.49707 18.335 9.09961 17.9697 9.09961 17.4541C9.09961 16.9707 9.49707 16.584 10.002 16.584H11.334V11.9648H10.2061C9.70117 11.9648 9.30371 11.5996 9.30371 11.084C9.30371 10.6006 9.70117 10.2139 10.2061 10.2139H12.333C12.9775 10.2139 13.3105 10.665 13.3105 11.3418V16.584H14.5352C15.0508 16.584 15.4482 16.9707 15.4482 17.4541C15.4482 17.9697 15.0508 18.335 14.5352 18.335H10.002Z"
  })));
};

InfoCircle.displayName = 'InfoCircle';
export default InfoCircle;